import { matchReportsDetailsWidget } from '@sky-it-livedata/livedata-football-widgets';
import { IMatchReportsDetail, MatchReportsDetail } from '@sky-it-livedata/livedata-sports-design-system';
import React, { useEffect } from 'react';

import { IGenericObject } from '../../typings/common-types';
import { getModelFromUseService, isEmptyObject } from '../../utils/props-validator';
import { useService } from '../hooks/useService';

interface IMatchReportsDetailWrapper {
  initialModel: any;
  query: IGenericObject;
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const SCROLL_OFFSET = 140;

const MatchReportsDetailWrapper = ({ initialModel, live, query }: IMatchReportsDetailWrapper) => {
  const { model } = useService({ live, query, initialValue: initialModel, widget: matchReportsDetailsWidget });
  const componentModel: IMatchReportsDetail = getModelFromUseService(model);

  useEffect(() => {
    if (!isEmptyObject(componentModel) && location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
        window.scrollTo({ top });
      }
    }
  }, [componentModel]);

  return !isEmptyObject(componentModel) ? <MatchReportsDetail {...componentModel} /> : null;
};

export default MatchReportsDetailWrapper;
